import { getTeamCreationJobs } from "../../../services/api.service.js";

export const teamCreationJobsQueryKey = ["teamCreationJobs"] as const;

export const getTeamCreationJobsQueryOptions = () => ({
  queryFn: () => getTeamCreationJobs(),
  queryKey: teamCreationJobsQueryKey,
});
